<template>
    <div class="stepAreaMain"> 
        <div class="row justify-content-center align-items-center stepFormTwo">
                <div class="middleBox mt-0">
                    
                    <div class="whiteBG p-3 Step-Form my-2 my-md-5 "> 
                        <h2 class="title mb-3 text-left pb-3 border-bottom ">{{$t('financial_details')}}</h2>
                        <!--loader - message--->
                        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
                        <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
                        <div class="pt-2">
                            <div class="stepForm "> 
                                <div class="row">
                                    <div class="col-12 mobPad">
                                        <h5 class="subtitle text-left mb-3">{{$t('reg_step_one_point')}}</h5>
                                        <div class="form-group d-flex flex-wrap justify-content-start align-items-center field-wrapper mb-3"> 
                                            <select class="customflaotField form-control" v-model="occupation" v-validate="'required'" name="occupation" :class="{ 'is-invalid': submittedRequest && errors.has('occupation') }" :disabled="disable">
                                                <option value="">Please Select...</option>
                                                <option v-for="(oList,key) in occupationList" :class="(occupation == key)?'selected' :''" :value="key">{{$t(oList)}} </option>
                                            </select>
                                            <p class="error w-100" v-if="submitted && errors.first('occupation')">Field is required</p>
                                        </div>
                                    </div>
                                    <div class="col-12 mobPad">
                                        <h5 class="subtitle text-left mb-3">{{$t('reg_step_one_point_two')}}</h5>
                                        <div class="form-group d-flex flex-wrap justify-content-start align-items-center field-wrapper mb-3">  
                                            <div class="customUserType multiSlct mb-2 mr-2" 
                                                v-for="(yList,key) in estYearlyIncome" 
                                                :class="(yearly_income == key)?'selected' :''"
                                            >
                                                <label class="customRadio-button border"> 
                                                  {{$t(yList)}}
                                                  <input 
                                                    type="radio" 
                                                    name="yearly_income" 
                                                    v-model="yearly_income" 
                                                    :value="key" 
                                                    :disabled="disable" 
                                                    v-validate="'required'"     
                                                    :class="{ 'is-invalid': submitted && errors.has(yearly_income) }" 
                                                    ref="yearly_incomeInput'">
                                                  <span class="checkmark"></span>
                                                </label>
                                            </div> 
                                            <div class="clearfix"></div>
                                          <p class="error w-100" v-if="submitted && errors.first('yearly_income')">The Yearly Income field is required</p>  
                                        </div>
                                    </div> 
                                    <div class="col-12 mobPad">
                                        <h5 class="subtitle text-left mb-3">{{$t('reg_step_one_point_three')}}</h5>
                                        <div class="form-group d-flex flex-wrap justify-content-start align-items-center field-wrapper mb-3">  
                                            <div class="customUserType multiSlct mb-2 mr-2"  v-for="(nList,key) in estNetWorth" :class="(net_worth == key)?'selected' :''">
                                                <label class="customRadio-button border"> 
                                                  {{$t(nList)}}
                                                  <input type="radio" name="net_worth" v-model="net_worth" :value="key" :disabled="disable" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has(net_worth) }" ref="net_worthInput'">
                                                  <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="clearfix"></div>                            
                                         <p class="error w-100" v-if="submitted && errors.first('net_worth')">The Estimated Net Worth field is required</p>
                                         </div>
                                    </div> 
                                    <!-- <div class="col-12 mobPad">
                                        <h5 class="subtitle text-left mb-3">Anticipated Account Turnover (Annual Net Deposits)</h5>
                                        <div class="form-group d-flex flex-wrap justify-content-start align-items-center field-wrapper mb-5 mobBottom-margin">  
                                            <div class="customUserType multiSlct mb-2 mr-2" v-for="(aList,key) in antAccountTurnover" :class="(account_turnover == key)?'selected' :''">
                                                <label class="customRadio-button border"> 
                                                  {{aList}}
                                                  <input type="radio" name="account_turnover" v-model="account_turnover" :value="key" :disabled="disable" v-validate="'required'"     :class="{ 'is-invalid': submitted && errors.has(account_turnover) }" ref="account_turnoverInput'">
                                                  <span class="checkmark"></span>
                                                </label>
                                            </div> 
                                            <div class="clearfix"></div>
                                            <p class="error w-100" v-if="submitted && errors.first('account_turnover')">The Account Turnover field is required</p>
                                         </div>
                                    </div> -->
                    				
                    				<div class="col-12 mobPad">
                                        <h5 class="subtitle text-left mb-3">{{$t('reg_step_one_point_four')}}</h5>
                                        <div class="form-group d-flex flex-wrap justify-content-start align-items-center field-wrapper mb-3 mobBottom-margin">  
                                            <div class="customUserType multiSlct mb-2 mr-2" v-for="(aList,key) in source_of_funds" :class="(source_of_fund == key)?'selected' :''">
                                                <label class="customRadio-button border"> 
                                                  {{$t(aList)}}
                                                  <input type="radio" name="source_of_fund" v-model="source_of_fund" :value="key" :disabled="disable" v-validate="'required'"     :class="{ 'is-invalid': submitted && errors.has(source_of_fund) }" ref="source_of_fundInput'">
                                                  <span class="checkmark"></span>
                                                </label>
                                            </div> 
                                            <div class="clearfix"></div>
                                            <p class="error w-100" v-if="submitted && errors.first('source_of_fund')">The source of funds field is required</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 mobPad">
                                    <div class="full-width border-top pt-3 submitButton align-items-center d-flex spacebetween mt-3 w-100">
                                        <div class="leftbtn">
                                            <router-link to="/step1" class="prism_btn btn_sm">Back</router-link>
                                        </div> 
                                        <button class="prism_btn btn_sm" v-on:click.prevent="submit()">Save & Continue</button>
                                    </div>
                                </div>                 
                            </div>
                        </div>
                    </div> 
            </div>
        </div>
    </div>
</template>
<script>
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'stepTwo',
        mixins: [fxViewMixins],
        data() {
            return {
                "emp_status" : '',
                "occupation" : '',
                "yearly_income" : '',
                "net_worth" : '',
                "account_turnover" : '',
				"source_of_fund" : '',
                "step" : 2,
                submitted: false,
                response_msg : '',
                userCountry : 'N/A',
                msg_type : '',
                pageLoader : false,
                disable: false,
                submittedRequest: false, 
            }
        },
        methods:{
            closeModalFunc(){
                this.$parent.$parent.showStepComponent = false
            },
            ...mapActions({
                _runRegisterStepTwo: types.RUN_REGISTER_STEP2,
                _runGetUserIp: types.RUN_GET_USER_IP
            }),
            submit(){
                if(this.disable){
                    let currentStep = this.get_user.step

                    if('tempStep' in this.get_user && currentStep < this.get_user.tempStep){
                        currentStep = this.get_user.tempStep
                    }
                    this.get_user.tempStep = currentStep
                    this.get_user.step = '2'         
                    let user_json = this.get_user
                    this.$store.commit(types.SET_STATE, user_json)
                }else{
                    const _that = this
                    _that.submitted = true;
                    _that.$validator.validate().then(valid => {
                        if (valid) {
                            let input_json={
                                'globalParams' :{
                                    'emp_status' : '1',
                                    'occupation' : _that.occupation.toString(),
                                    'usFatca': _that.usFatca,
                                    'yearly_income' : _that.yearly_income.toString(),
                                    'net_worth' : _that.net_worth.toString(),
                                    'account_turnover' : '1',
                                    'source_of_fund' : _that.source_of_fund.toString(),
                                    'step' : _that.step.toString(),
                                    "ip_country": this.userCountry
                                },
                                'localParams' :{
                                    "parameter" : _that
                                }
                            }
                            _that._runRegisterStepTwo(input_json)
                        }else{
                            _that.handleValidationErrorAdvanced(_that.errors)
                        }
                    });
                }
            },
        },
        created(){
            this._runGetUserIp({'globalParams' :{},'localParams' :{ "parameter" : this } })
            if(parseInt(this.get_user.profile.ipv_status)){
                this.disable = true;
            }
            this._runGetUserRegisterationStepData({'globalParams' :{},'localParams' :{ "parameter" : this , "step" : '2'}})
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/registerSteps/step2.vue